import { Moment } from 'moment';
import {
  IcmsBaseCalculationDeterminationMode,
  IcmsOrigin,
  InvoiceExigibility,
  InvoiceIcmsCstCsosn,
  InvoiceTaxType,
  IpiCst,
  PisCofinsCst,
  TaxRegimeEnum,
} from '../invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import {
  InvoiceOperationType,
  InvoiceSpecialTaxRegime,
  InvoiceTaxationNature,
  InvoiceTaxRegime,
  InvoiceTypeOfStreet,
} from '../invoices/invoices.enums';
import {
  InvoiceSettingEnvironment,
  TaxAssessmentRegime,
} from './Settings.enums';
import { InvoiceItemTaxesIbsCbsCst } from '../invoiceNoteItems/invoiceNoteItemsParts/invoiceNoteItems.enums';

export enum EmissionEnvironmentEnum {
  staging = 'STAGING',
  production = 'PRODUCTION',
}

export enum TypeOfDigitalCertificateEnum {
  uploadToSystem = 'UPLOAD_TO_SYSTEM',
  installedOnTheMachine = 'INSTALLED_ON_THE_MACHINE',
}

export enum CodeUsedInDanfeEnum {
  manufacturerCode = 'MANUFACTURER_CODE',
  internalCode = 'INTERNAL_CODE',
  barCode = 'BAR_CODE',
  standardNFECode = 'STANDAR_NFC_CODE',
}

export enum ChargeabilityIssEnum {
  chargeable = 'CHARGEABLE',
  notIncident = 'NOT_INCIDENT',
  exemption = 'EXEMPTION',
  export = 'EXPORT',
  Immunity = 'IMMUNITY',
  judicialSuspension = 'JUDICIAL_SUSPENSION',
  administrativeSuspension = 'ASMINISTRATIVE_SUSPENSION',
}

export enum SpecialTaxRegimeEnum {
  microEnterprise = 'MICRO_ENTERPRISE',
  estimated = 'ESTIMATED',
  society = 'SOCIETY',
  cooperative = 'COOPERATIVE',
  mei = 'MEI',
  meepp = 'MEEPP',
}

export enum YesNoEnum {
  yes = 'YES',
  no = 'NO',
}

export enum selectCpfCnpjEnum {
  cpf = 'CPF',
  cnpj = 'CNPJ',
}

export enum NfeIssueEnum {
  normal = 'NORMAL',
  contingency = 'CONTINGENCY',
}

export type StateValidUf =
  | 'am'
  | 'ba'
  | 'ce'
  | 'df'
  | 'es'
  | 'go'
  | 'ma'
  | 'mt'
  | 'ms'
  | 'mg'
  | 'pa'
  | 'pb'
  | 'pr'
  | 'pe'
  | 'pi'
  | 'rj'
  | 'rn'
  | 'rs'
  | 'ro'
  | 'rr'
  | 'sc'
  | 'sp'
  | 'se'
  | 'to'
  | 'ac'
  | 'al'
  | 'ap';

export const StateType = {
  am: 'Amazonas',
  ba: 'Bahia',
  ce: 'Ceará',
  df: 'Distrito Federal',
  es: 'Espírito Santo',
  go: 'Goiás',
  ma: 'Maranhão',
  mt: 'Mato Grosso',
  ms: 'Mato  Grosso do Sul',
  mg: 'Minas Gerais',
  pa: 'Pará',
  pb: 'Paraíba',
  pr: 'Paraná',
  pe: 'Pernambuco',
  pi: 'Piauí',
  rj: 'Rio de Janeiro',
  rn: 'Rio Grande do Norte',
  rs: 'Rio Grande do Sul',
  ro: 'Rondônia',
  rr: 'Roraima',
  sc: 'Santa Catarina',
  sp: 'São Paulo',
  se: 'Sergipe',
  to: 'Tocantins',
  ac: 'Acre',
  al: 'Alagoas',
  ap: 'Amapá',
};

interface Invoice {
  model: number;
  series: number;
  cfopId: number;
  lastNfeNumber: string;
  generateInvoice: boolean;
  generateTag: boolean;
  idCsrt: number;
  securityCode: number;
}

export interface CompanyInvoiceSettingsRequest {
  quotaFcpSettingsRequestDTO: QuotaFcpSettingsRequest[];
  quotaFcpSettingsList: QuotaFcpSettingsRequest[];
  certificateFile?: string;
  certificatePassword?: string;
  cfopId?: number;
  cfopIdNfs?: number;
  chargeabilityIss?: ChargeabilityIssEnum;
  cldToken?: string;
  codeUsedInDanfe?: CodeUsedInDanfeEnum;
  companyId?: number;
  cpfCnpj?: string;
  csosn?: string;
  cstCofins?: string;
  cstIcms?: string;
  cstIpi?: string;
  cstPis?: string;
  culturalIncentive?: boolean;
  email?: string;
  environment?: InvoiceSettingEnvironment;
  framingCode?: string;
  generatePartsFranchiseInvoice?: boolean;
  generateinfRespTecTag?: boolean;
  idCsrt?: string;
  issueCF?: boolean;
  issueCombinedInvoice?: boolean;
  issueNfc?: boolean;
  issueNfe?: boolean;
  lastNfceNumber?: number;
  lastNfeNumber?: number;
  model?: string;
  modelNfce?: string;
  nfeAdditionalDevolution?: string;
  nfeAdditionalEmail?: string;
  nfeAdditionalSale?: string;
  nfeAdditionalService?: string;
  nfeIssue?: NfeIssueEnum;
  quotaCofins?: number;
  quotaCsll?: number;
  quotaISSQN?: number;
  quotaIpi?: number;
  quotaPart?: number;
  quotaPis?: number;
  quotaService?: number;
  responsibleSecurityCode?: string;
  securityCodeNfce?: string;
  series?: string;
  seriesNfce?: string;
  specialTaxRegime?: SpecialTaxRegimeEnum;
  synchronousProcessOnNfc?: boolean;
  taxPercentage?: number;
  id: number;
}

export interface AuthorizationDownloadXmlRequestDTO {
  cpfCnpj: string;
  email: string;
  id?: number;
  selectCpfCnpj?: selectCpfCnpjEnum;
  invoiceSettingsId: number;
}

export interface CompanyInvoiceSettingsResponse {
  cfopId?: {
    billing: boolean;
    code: string;
    description: string;
    id: number;
    inState: boolean;
    output: boolean;
    outsideCountry: boolean;
  };
  companyId: number;
  environment: EmissionEnvironmentEnum;
  id: number;
}

interface ConsumerInvoice {
  modelConsumer: number;
  seriesConsumer: number;
  securityCodeConsumer: number;
  cldToken: string;
  sendNFCe: boolean;
  lastNfceNumber: string;
}

interface SatTax {
  version: string;
  cashierNumber: string;
  serialNumber: string;
  activationCode: string;
  subscriptionKey: string;
}

interface Settings {
  aliquotService: string;
  aliquotPart: string;
  aliquotCsll: string;
  csosn: string;
  cstIcms: string;
  framingCode: string;
  cstIpi: string;
  aliquotIpi: string;
  cstPis: string;
  aliquotPis: string;
  cstCofins: string;
  aliquotCofins: string;
}

interface ServiceInvoice {
  seriesService: string;
  specialDiet: SpecialTaxRegimeEnum;
  municipalCode: string;
}

interface AdditionalData {
  NFeSale: 'NFE_SALE';
  NFeService: 'NFE_SERVICE';
  NFeDevolution: 'NFE_DEVOLUTION';
  NFeEmail: 'NFE_EMAIL';
}

export interface AuthorizationDownloadXml {
  selectCpfCnpj: selectCpfCnpjEnum;
  cpfCnpj: number;
  email: string;
}

export type CompanyInvoiceFormValues = Invoice &
  ConsumerInvoice &
  SatTax &
  Settings &
  ServiceInvoice &
  AdditionalData &
  AuthorizationDownloadXml & {
    emissionEnvironment: EmissionEnvironmentEnum;
    issueInvoice: boolean;
    issueConsumerInvoice: boolean;
    issueTaxCoupon: boolean;
    issueCombinedInvoice: boolean;
    typeOfDigitalCertificateEnum: TypeOfDigitalCertificateEnum;
    useUnife: boolean;
    certificatePassword: string;
    danfeCodeType: CodeUsedInDanfeEnum;
    ServiceCode: YesNoEnum;
    deductISS: YesNoEnum;
    pisCofins: YesNoEnum;
    culturalIncentive: YesNoEnum;
    taxPercentage: string;
    aliquotISSQN: string;
    issuanceNFSe: string;
    additionalData: AdditionalData;
  };

// Novo modelo de requisição

export enum EnvironmentEnum {
  production = 'PRODUCTION',
  homologation = 'HOMOLOGATION',
}

export enum ContractModelEnum {
  ticketing = 'TICKETING',
  unlimited = 'UNLIMITED',
}

export enum CompanyTaxRegimeEnum {
  none = 'NONE',
  simpleNational = 'SIMPLE_NATIONAL',
  simpleNationalExcess = 'SIMPLE_NATIONAL_EXCESS',
  normalPresumedProfit = 'NORMAL_PRESUMED_PROFIT',
  normalActualProfit = 'NORMAL_ACTUAL_PROFIT',
}

export enum SpecialTaxSystemEnum {
  NoSpecialTaxRegime = 'NO_SPECIAL_TAX_REGIME',
  municipalMicroEnterprise = 'MUNICIPAL_MICRO_ENTERPRISE',
  estimated = 'ESTIMATED',
  societyOfProfessionals = 'SOCIETY_OF_PROFESSIONALS',
  cooperative = ' COOPERATIVE',
  individualMicroentrepreneurMei = 'INDIVIDUAL_MICROENTREPRENEUR_MEI',
  MicroOrSmallBusinessMeEpp = 'MICRO_OR_SMALL_BUSINESS_ME_EPP',
  realProfit = 'REAL_PROFIT',
  presumedProfit = 'PRESUMED_PROFIT',
  standardtaxation = 'STANDARD_TAXATION',
  simpleNationalWithExcessSublimit = 'SIMPLE_NATIONAL_WITH_EXCESS_SUBLIMIT',
  limitedLiabilityCompany = 'LIMITED_LIABILITY_COMPANY',
}

export enum TypeOfStreetEnum {
  avenue = 'AVENUE',
  avenue2 = 'AVENUE2',
  farm = 'FARM',
  cologne = 'COLOGNE',
  condominium = 'CONDOMINIUM',
  eqnp = 'EQNP',
  estancia = 'ESTANCIA',
  road = 'ROAD',
  ranch = 'RANCH',
  square = 'SQUARE',
  extension = 'EXTENSION',
  highway = 'HIGWAY',
  road2 = 'ROAD2',
  place = 'PLACE',
  platter = 'PLATTER',
  vicinal = 'VICINAL',
}

export enum ContingencyEmissionTypeEnum {
  NORMAL_EMISSION = 'NORMAL_EMISSION',
  SVCAN = 'SVCAN',
  SVCRS = 'SVCRS',
  FSIA = 'FSIA',
  FSDA = 'FSDA',
}

export interface CompanyInvoiceSettingsForm {
  issueNfe: boolean;
  issueNfc: boolean;
  issueNfs: boolean;
  issueCfe: boolean;

  nfsLogin?: string;
  nfsPassword?: string;

  // Details
  stateRegistration: string;
  municipalRegistration: string;
  taxRegime: InvoiceTaxRegime;
  specialTaxRegime: InvoiceSpecialTaxRegime;
  culturalIncentive: boolean;
  taxIncentive: boolean;
  id: number;
  isRegisteredOnPlugNotas: boolean;
  insertValueInCodeBar: boolean;
  showValueTotalInvoiceInListing: boolean;

  // Address
  typeOfStreet: InvoiceTypeOfStreet;
  city: string;
  cityId: number;
  complement?: string;
  district: string;
  number: string;
  street: string;
  zipCode: string;
  state: string;
  delivery?: boolean;
  main?: boolean;
  description?: string;

  // Contact
  ddd: string;
  phone: string;
  email: string;

  // Invoice
  environment?: InvoiceSettingEnvironment;
  contractModel?: ContractModelEnum;
  autoEmail: boolean;

  nfe: {
    cfopId: number;
    emailSending: boolean;
    fcpPrinting: boolean;
    additionalPurchaseReturnInformationDefault: string;
    automaticIbptCalculation: boolean;
    cofinsAliquotDefault: number;
    cofinsCstDefault: PisCofinsCst;
    companyAdditionalDataDefault: string;
    initialNumber: number;
    icmsCstDefault: InvoiceIcmsCstCsosn;
    icmsOriginDefault: IcmsOrigin;
    id: number;
    invoiceNumberings: InvoiceNumberings[];
    ipiAliquotDefault: number;
    ipiCstDefault: IpiCst;
    ipiLegalClassificationCodeDefault: string;
    pisAliquotDefault: number;
    pisCstDefault: PisCofinsCst;
    sharingPrinting: boolean;
    taxAdditionalDataDefault: string;
    taxRegimeDefault: TaxRegimeEnum;
    series: string;
    unitMeasurementDefault: string;
    natureOfOperationDefault: string;
    generalIbptRate?: number;
    shouldNotDeductExemptIcmsDefault: boolean;
    emissionType?: ContingencyEmissionTypeEnum;
    simpleNationalCreditRateDefault?: number;
    stateCsrtId?: number;
  };

  nfs: {
    activeNfseNacional: boolean;
    series: string;
    initialRpsNumber: number;
    securityCodeNfce: string;
    automaticIbptCalculation: boolean;
    automaticNumbering: boolean;
    batch: number;
    companyAdditionalDataDefault: string;
    grossRevenue: number;
    id: number;
    invoiceNumberings: InvoiceNumberings[];
    issqnServiceCodeDefault: string;
    law: string;
    login: string;
    password: string;
    rateDefault: number;
    sendEmail: boolean;
    startDate: Moment;
    taxCodeDefault: string;
    taxTypeDefault: InvoiceTaxType;
    unitMeasurementDefault: string;
    exigibilityDefault: InvoiceExigibility;
    withheldDefault: string;
    deductDiscountItemValue: boolean;
    generalIbptRate: number;
    stateIbptRate: number;
    municipalIbptRate: number;
    federalIbptRate: number;
    breakLineByDefault: boolean;
    calculateWithheldIssInWorkOrder?: boolean;
    deductUnconditionalDiscountFromTaxBase?: boolean;
    groupInvoiceItemsNfsBySubArea?: boolean;
    operationIndicatorCodeDefault?: string;
    operationTypeDefault?: InvoiceOperationType;
    taxationNatureDefault?: InvoiceTaxationNature;
    zeroOutIssValueNotWithheld?: boolean;
  };

  nfc: {
    automaticIbptCalculation: boolean;
    cldToken: string;
    cofinsAliquotDefault: number;
    cofinsCstDefault: PisCofinsCst;
    companyAdditionalDataDefault: string;
    emailDelivery: boolean;
    initialNumber: number;
    icmsCstDefault: InvoiceIcmsCstCsosn;
    icmsOriginDefault: IcmsOrigin;
    id: number;
    invoiceNumberings: InvoiceNumberings[];
    ipiAliquotDefault: number;
    ipiCstDefault: IpiCst;
    ipiLegalClassificationCodeDefault: string;
    pisAliquotDefault: number;
    pisCstDefault: PisCofinsCst;
    series: string;
    securityCodeNfce: string;
    taxAdditionalDataDefault: string;
    taxRegimeDefault: TaxRegimeEnum;
    unitMeasurementDefault: string;
    natureOfOperationDefault: string;
    shouldNotDeductExemptIcmsDefault: boolean;
    useQrCodeVersion3: boolean;
    simpleNationalCreditRateDefault?: number;
    stateCsrtId?: number;
  };

  // Authentication
  certificateFile?: string;
  certificatePassword?: string;
  certificateEmail?: string;

  // Aliquot
  quotaFcpSettingsRequestDTO: QuotaFcpSettingsResponse[];
}

export interface InvoiceNumberings {
  id: number;
  initialNumber: string;
  main: boolean;
  series: string;
}

export interface InvoiceSettingConfigNFc {
  id?: number;
  automaticIbptCalculation?: boolean;
  cldToken?: string;
  emailDelivery?: boolean;
  initialNumber?: number;
  securityCodeNfce?: string;
  series?: string;
  invoiceNumberings?: InvoiceNumberings[];
  companyAdditionalDataDefault?: string;
  taxAdditionalDataDefault?: string;
  natureOfOperationDefault?: string;
  // tributes
  taxRegimeDefault: TaxRegimeEnum;
  icmsBaseCalculationDeterminationModeDefault?: IcmsBaseCalculationDeterminationMode;
  icmsCstDefault: InvoiceIcmsCstCsosn;
  icmsAliquotDefault?: number;
  icmsOriginDefault: IcmsOrigin;
  pisCstDefault: PisCofinsCst;
  pisAliquotDefault: number;
  ipiAliquotDefault: number;
  ipiCstDefault: IpiCst;
  ipiLegalClassificationCodeDefault: string;
  cofinsCstDefault: PisCofinsCst;
  cofinsAliquotDefault: number;
  csllAliquotDefault?: number;
  irrfAliquotDefault?: number;
  shouldNotDeductExemptIcmsDefault?: boolean;
  unitMeasurementDefault?: string;
  // Tax reform
  selectiveTaxAliquotDefault?: number;
  selectiveTaxClassificationCodeDefault?: string;
  selectiveTaxCstDefault?: string;
  ibsCbsCstDefault?: InvoiceItemTaxesIbsCbsCst;
  ibsCbsTaxClassificationDefault?: string;
  ibsMunicipalAliquotDefault?: number;
  ibsUfAliquotDefault?: number;
  cbsAliquot?: number;
  useQrCodeVersion3: boolean;
  simpleNationalCreditRateDefault?: number;
  stateCsrtId?: number;
}

export interface InvoiceSettingConfigNFe {
  id?: number;
  automaticIbptCalculation?: boolean;
  emailSending?: boolean;
  fcpPrinting?: boolean;
  initialNumber?: number;
  series?: string;
  sharingPrinting?: boolean;
  invoiceNumberings?: InvoiceNumberings[];
  cfopId?: number;
  companyAdditionalDataDefault?: string;
  taxAdditionalDataDefault?: string;
  additionalPurchaseReturnInformationDefault?: string;
  natureOfOperationDefault?: string;
  generalIbptRate?: number;
  // tributes
  taxRegimeDefault: TaxRegimeEnum;
  icmsBaseCalculationDeterminationModeDefault?: IcmsBaseCalculationDeterminationMode;
  icmsCstDefault: InvoiceIcmsCstCsosn;
  icmsAliquotDefault?: number;
  icmsOriginDefault: IcmsOrigin;
  pisCstDefault: PisCofinsCst;
  pisAliquotDefault: number;
  ipiAliquotDefault: number;
  ipiCstDefault: IpiCst;
  ipiLegalClassificationCodeDefault: string;
  cofinsCstDefault: PisCofinsCst;
  cofinsAliquotDefault: number;
  csllAliquotDefault?: number;
  irrfAliquotDefault?: number;
  shouldNotDeductExemptIcmsDefault?: boolean;
  unitMeasurementDefault?: string;
  // Tax reform
  selectiveTaxAliquotDefault?: number;
  selectiveTaxClassificationCodeDefault?: string;
  selectiveTaxCstDefault?: string;
  ibsCbsCstDefault?: InvoiceItemTaxesIbsCbsCst;
  ibsCbsTaxClassificationDefault?: string;
  ibsMunicipalAliquotDefault?: number;
  ibsUfAliquotDefault?: number;
  cbsAliquot?: number;
  simpleNationalCreditRateDefault?: number;
  stateCsrtId?: number;
}

export interface InvoiceSettingConfigNFs {
  activeNfseNacional: boolean;
  id?: number;
  automaticIbptCalculation?: boolean;
  automaticNumbering?: boolean;
  batch?: number;
  grossRevenue?: number;
  initialRpsNumber?: number;
  law?: string;
  login?: string;
  password?: string;
  sendEmail?: boolean;
  series?: string;
  startDate?: string;
  invoiceNumberings?: InvoiceNumberings[];
  companyAdditionalDataDefault?: string;
  taxCodeDefault?: string;
  rateDefault: number;
  taxTypeDefault: InvoiceTaxType;
  exigibilityDefault: InvoiceExigibility;
  unitMeasurementDefault: string;
  withheldDefault?: boolean;
  csllAliquotDefault?: number;
  irrfAliquotDefault?: number;
  generalIbptRate?: number;
  municipalIbptRate?: number;
  stateIbptRate?: number;
  federalIbptRate?: number;
  issqnServiceCodeDefault?: string;
  calculateWithheldIssInWorkOrder?: boolean;
  deductUnconditionalDiscountFromTaxBase?: boolean;
  taxAssessmentRegime?: TaxAssessmentRegime;
  groupInvoiceItemsNfsBySubArea?: boolean;
  // Tax reform
  ibsCbsCstDefault?: InvoiceItemTaxesIbsCbsCst;
  ibsCbsTaxClassificationDefault?: string;
  ibsMunicipalAliquotDefault?: number;
  ibsUfAliquotDefault?: number;
  cbsAliquot?: number;
  selectiveTaxAliquotDefault?: number;
  selectiveTaxClassificationCodeDefault?: string;
  selectiveTaxCstDefault?: string;
  operationIndicatorCodeDefault?: string;
  operationTypeDefault?: InvoiceOperationType;
  nbsCodeDefault?: string;
  taxationNatureDefault?: InvoiceTaxationNature;
}

export interface StateCsrt {
  id: number;
  idCsrt: number;
  csrt: string;
  state: string;
}

export interface InvoiceSettingsData {
  certificateId?: number;
  cityId: number;
  companyId: number;
  configNfc?: InvoiceSettingConfigNFc;
  configNfe?: InvoiceSettingConfigNFe;
  configNfs?: InvoiceSettingConfigNFs;
  culturalIncentivator?: boolean;
  environment?: InvoiceSettingEnvironment;
  id?: number;
  isRegisteredOnPlugNotas: boolean;
  issueNfc: boolean;
  issueNfe: boolean;
  issueNfs: boolean;
  issueCfe: boolean;
  municipalRegistration?: string;
  simpleNational?: boolean;
  specialTaxRegime: InvoiceSpecialTaxRegime;
  taxIncentive: boolean;
  isAnotherCompanyActive?: boolean;
  useInternalInvoiceApiNfc?: boolean;
  useInternalInvoiceApiNfe?: boolean;
  useInternalInvoiceApiNfs?: boolean;
  showValueTotalInvoiceInListing?: boolean;
  groupInvoiceItemsNfsBySubArea?: boolean;
}

// Alíquota

export interface QuotaFcpSettingsForm {
  ac: number;
  al: number;
  am: number;
  ap: number;
  ba: number;
  ce: number;
  df: number;
  es: number;
  go: number;
  ma: number;
  mg: number;
  ms: number;
  mt: number;
  pa: number;
  pb: number;
  pe: number;
  pi: number;
  pr: number;
  rj: number;
  rn: number;
  ro: number;
  rr: number;
  rs: number;
  sc: number;
  se: number;
  sp: number;
  to: number;
}

export type QuotaFcpSettingsRequest = QuotaFcpSettingsForm;

export interface QuotaFcpSettingsResponse extends QuotaFcpSettingsForm {
  invoiceSettingsId: number;
}
